import { ActionType, createReducer } from 'typesafe-actions';
import {
  changeModeAction,
  decrementNeighboursAction,
  incrementNeighboursAction,
  refreshBetsAction,
  setSelectionAction,
  setSelectionOnRaceTrackAction,
  saveWinnerToStoreAction,
  addConfirmedBetAction,
  setConfirmedBetAction,
  clearAllBetsAction,
} from './actions';
import { IBetsArea, Modes, ModifiedBets } from 'widgets/Roulette/types';
import { getComplexWinners, getSelectionStraights } from 'widgets/Roulette/helpers';
import { BetsTypes, neighboursCountLimit } from 'widgets/Roulette/const';

export const defaultState: IBetsArea = {
  bets: {
    past: [],
    present: {},
    future: [],
  },
  betsConfirmed: [],
  neighboursCount: 2,
  mode: Modes.full,
  tableSurface: {
    selected: [],
    raceTrackSelected: [],
    winners: [],
  },
};

const actions = {
  refreshBetsAction,
  setSelectionAction,
  setSelectionOnRaceTrackAction,
  incrementNeighboursAction,
  decrementNeighboursAction,
  changeModeAction,
  saveWinnerToStoreAction,
  addConfirmedBetAction,
  setConfirmedBetAction,
  clearAllBetsAction,
};

export const rouletteBetReducer = createReducer<IBetsArea, ActionType<typeof actions>>(defaultState)
  .handleAction(refreshBetsAction, (state, { payload }) => {
    const { past, present, future } = payload;

    return {
      ...state,
      bets: {
        past,
        present,
        future,
      },
    };
  })
  .handleAction(setSelectionAction, (state: IBetsArea, { payload }) => {
    const { bets } = payload || { bets: null };
    const selected: ModifiedBets = bets ? getSelectionStraights(bets) : [];
    return { ...state, tableSurface: { ...state.tableSurface, selected } };
  })
  .handleAction(setSelectionOnRaceTrackAction, (state: IBetsArea, { payload }) => {
    const raceTrackSelected: ModifiedBets = payload ? getSelectionStraights(payload) : [];
    return { ...state, tableSurface: { ...state.tableSurface, raceTrackSelected } };
  })
  .handleAction(incrementNeighboursAction, (state: IBetsArea) => {
    const valueAfterIncrement = state.neighboursCount;

    if (valueAfterIncrement >= neighboursCountLimit.max) {
      return state;
    }

    return {
      ...state,
      neighboursCount: state.neighboursCount + 1,
    };
  })
  .handleAction(decrementNeighboursAction, (state: IBetsArea) => {
    const valueAfterDecrement = state.neighboursCount - 1;

    if (valueAfterDecrement < neighboursCountLimit.min) {
      return state;
    }

    return {
      ...state,
      neighboursCount: valueAfterDecrement,
    };
  })
  .handleAction(changeModeAction, (state: IBetsArea, { payload: { mode } }) => ({
    ...state,
    mode,
  }))
  .handleAction(saveWinnerToStoreAction, (state: IBetsArea, { payload: { winner } }) => {
    if (!winner) {
      return {
        ...state,
        tableSurface: {
          ...state.tableSurface,
          winners: [],
        },
      };
    }
    const selector = [winner].toString();

    const complexWinnersSelectors: ModifiedBets =
      winner.toString() === BetsTypes.zero ? [] : getComplexWinners(winner);

    return {
      ...state,
      tableSurface: {
        ...state.tableSurface,
        winners: [selector, ...complexWinnersSelectors],
      },
    };
  })
  .handleAction(addConfirmedBetAction, (state, { payload: confirmedBet }) => ({
    ...state,
    betsConfirmed: [...state.betsConfirmed, ...confirmedBet],
  }))
  .handleAction(setConfirmedBetAction, (state, { payload: confirmedBet }) => ({
    ...state,
    betsConfirmed: confirmedBet,
  }))
  .handleAction(clearAllBetsAction, (state) => ({
    ...state,
    bets: defaultState.bets,
    betsConfirmed: defaultState.betsConfirmed,
  }));
